import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export default function CommonModal({
  toggle,
  open,
  messageForPopUp,
  buttonText,
  modalAction,
  closeButtonText,
  fromCustomer,
  closeButtonAction,
  dontShowCloseButton,
  newLineMessage,
  modalHeader = "",
 isSave,
}) {
  return (
    <Modal
      backdrop="static"
      centered={true}
      toggle={toggle}
      isOpen={open}
      className="rv-modal"
    >
      <ModalHeader className="w-100 justify-content-center p-13 position-relative rv-breadcrumb-border ">
        {modalHeader}
        <button
          type="button"
          className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
          onClick={toggle}
        >
          &times;
        </button>
      </ModalHeader>
      <ModalBody className="fs-5 fw-bold text-center">
        {messageForPopUp}
        {newLineMessage ? <div>{newLineMessage}</div> : ""}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center align-items-center p-4">
        <div className="d-flex flex-row gap-3">
          {fromCustomer !== "Customer" ? (
            !dontShowCloseButton && (
              <Button
                onClick={toggle}
                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              >
                <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-1" />

                <span className="ps-3 px-2 ms-2 me-1 modal-btn">Cancel</span>
              </Button>
            )
          ) : (
            <Button
              onClick={closeButtonAction}
              className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            >
              <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-1" />

              <span className="ps-2 ms-2 me-1 modal-btn">
                {closeButtonText}
              </span>
            </Button>
          )}
          {/* <Button onClick={modalAction} >
                    {buttonText}
                </Button> */}
          <Button
            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            onClick={modalAction}
          >
            {/* <i className="ri-delete-bin-line label-icon align-middle fs-16 me-1"></i> */}
            <i
  className={`${
    isSave
      ? "ri-checkbox-circle-line"
      : "ri-delete-bin-line"
  } label-icon align-middle fs-16 me-1`}
></i>
            <span className="ps-3 px-2 ms-2 me-1 modal-btn">{buttonText}</span>
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
